/**
 * Apple Music "Open in Apple Music" deep-link.
 *
 * Apple Music has no curator / shared-playlist API (the user-token is device-
 * bound, non-refreshable, and 403s when reused server-side — see project memory
 * apple-music-integration-2026-06-04). So unlike Spotify/YouTube there is no
 * playlist URL to open; the honest universal affordance is a per-track search
 * deep-link built from the song + artist. Token-free (no developer token /
 * MusicKit required), works for every track — including ones that failed
 * Spotify/YouTube matching — and resolves to the visitor's own storefront.
 *
 * This stays the right affordance for a VISITOR. A signed-in owner has a
 * second, heavier path: user-authorised export of a whole playlist into their
 * own library (src/lib/appleMusicExport.ts). That one needs an Apple sign-in
 * and a subscription, which is exactly why it did not replace this.
 */
export function appleMusicSearchUrl(song: string, artist: string): string {
  const term = `${song ?? ""} ${artist ?? ""}`.trim().replace(/\s+/g, " ");
  return `https://music.apple.com/search?term=${encodeURIComponent(term)}`;
}
